export const defaultMoneyMaskOptions = {
  decimal: ',',
  thousands: ' ',
  precision: 0,
  masked: false /* doesn't work with directive */
}
